// extracted by mini-css-extract-plugin
export default {"loadingContainer":"AudienceIntegrationLogDetails_loadingContainer__L3d7r","contentContainer":"AudienceIntegrationLogDetails_contentContainer__VfNzu"};